import { atom } from 'recoil'

export const enquiryModalDisplayState = atom({
  key: 'enquiryModalDisplayState',
  default: {
    display: false,
    type: 'default',
    entity: {}
  }
})

